import React from 'react';
import type { ExportTag } from '../../hooks/useExports';

interface TagPillProps {
  tag: ExportTag | null | undefined;
}

export function TagPill({ tag }: TagPillProps) {
  if (!tag) return null;
  return (
    <span className="tag">
      <span className="btn-group">
        <button className="btn btn-sm btn-default" type="button">
          {tag.color && <i className="fas fa-circle" style={{ color: tag.color }} aria-hidden="true" />}
          {' '}{tag.name}
        </button>
      </span>
    </span>
  );
}

interface TagLabelsProps {
  tags?: ExportTag[];
}

export function TagLabels({ tags }: TagLabelsProps) {
  if (!tags?.length) return null;
  return (
    <>
      {tags.map(t => (
        <TagPill key={t.id} tag={t} />
      ))}
    </>
  );
}
